import { render, staticRenderFns } from "./AicLegalConfirmationModal.vue?vue&type=template&id=47cbb870&scoped=true"
import script from "./AicLegalConfirmationModal.vue?vue&type=script&lang=ts"
export * from "./AicLegalConfirmationModal.vue?vue&type=script&lang=ts"
import style0 from "./AicLegalConfirmationModal.vue?vue&type=style&index=0&id=47cbb870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cbb870",
  null
  
)

export default component.exports